import { AfterViewInit, Component, Injector, OnInit, ViewChild } from '@angular/core';
import { UserGroupType } from 'tnx-admin-service/authorization/constants';
import { RoleService } from 'tnx-admin-service/authorization/role/services';
import { ColumnSchemaBase, ComCtxConstants, ComponentContextService, CrudListComponent, DataListBase, HeightType, ModelSchema, Operator, UserGroupService } from 'tnx-shared';

@Component({
    selector: 'app-user-role',
    templateUrl: './user-role.component.html',
    styleUrls: ['./user-role.component.scss'],
    providers: [ComponentContextService]
})
export class UserRoleComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};
    submitting: any;
    countLoading: any;

    searchText: any;
    roleEditable: any[];
    originalRoleIds: any[];
    roleIds: any[];

    constructor(
        protected _injector: Injector,
        protected _roleService: RoleService
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.baseService = this._roleService;
        this.setting.objectName = 'nhóm người dùng';
        this.setting.popupSize.height = 700;
        this.setting.popupSize.width = 1000;
        this.setting.showExportAll = false;
        this.setting.hiddenPageTitle = true;
        this.setting.hiddenAdvanceSearch = true;
        this.setting.heightType = HeightType.custom;

        this.setting.modelSchemas = [
            new ModelSchema({ field: 'code', name: 'Mã', fullName: 'Mã', description: 'Mã' }),
            new ModelSchema({ field: 'name', name: 'Tên', fullName: 'Tên', description: 'Tên' }),
            new ModelSchema({ field: 'description', name: 'Mô tả', fullName: 'Mô tả', description: 'Mô tả' }),
        ];

        this.setting.cols = [
            new ColumnSchemaBase({ field: 'code' }),
            new ColumnSchemaBase({ field: 'name' }),
        ];

        this.parentContext.subscribe('SELECTED_OBJECT_CHANGED', async data => {
            if (!data.ids || data.ids.length == 0) {
                this.reset();
                return;
            }

            if (data.type == UserGroupType.User) {
                await this.onSelectedUser(data);
            }
            else {
                await this.onSelectedUserGroup(data);
            }
        });

        this.parentContext.subscribe(ComCtxConstants.PERMISSION.REFRESH_USER_PERMISSION, () => {
            this.reload();
            this.reset();
        })

        this.reset();
        super.ngOnInit();
    }

    async onSelectedUser(data) {
        let requestModel = {
            idUsers: data.ids,
            userGroupType: null
        };

        const allRoleResponse = await this._roleService.GetIdByUsers(requestModel);

        requestModel = {
            idUsers: data.ids,
            userGroupType: UserGroupType.Group
        };

        const roleAssignToGroupUser = await this._roleService.GetIdByUsers(requestModel);
        const intersectResponse = await this._roleService.GetIntersectIdByUsers(data.ids);
        const intersectDirectResponse = await this._roleService.GetIntersectDirectIdByUsers(data.ids);

        this.roleEditable = intersectDirectResponse.data.filter(x => roleAssignToGroupUser.data.every(k => k != x));
        this.originalRoleIds = allRoleResponse.data;
        this.roleIds = [...intersectResponse.data];
    }

    async onSelectedUserGroup(data) {
        const requestModel = {
            idUserGroups: data.ids,
            userGroupType: null
        };

        const allRoleResponse = await this._roleService.GetIdByGroupUsers(requestModel);
        const intersectResponse = await this._roleService.GetIntersectIdByGroupUsers(data.ids);
        const editableRoleResponse = await this._roleService.GetIntersectDirectIdByGroupUsers(data.ids);

        this.roleEditable = [...editableRoleResponse.data];
        this.originalRoleIds = allRoleResponse.data;
        this.roleIds = [...intersectResponse.data];
    }

    reset() {
        this.roleEditable = [];
        this.originalRoleIds = [];
        this.roleIds = [];

        this.parentModel.advanceData.role = {
            addRoleIds: [],
            removeRoleIds: []
        };
    }

    async modifyGridInfo(gridInfo) {
        gridInfo.filters.push(this.newFilter('type', Operator.equal, UserGroupType.Group));
        if (this.searchText) {
            gridInfo.filters.push(this._crudService.buildMultiFilterContains(['code', 'name'], this.searchText));
        }
    }

    onChangeSelect(event) {
        var addRole = this.roleIds.filter(x => this.originalRoleIds.every(k => k != x));
        var removeRole = this.roleEditable.filter(x => this.roleIds.every(k => k != x));

        this.parentModel.advanceData.role = {
            addRoleIds: addRole,
            removeRoleIds: removeRole
        };
    }

    toggleCheckAll(event) {
        if (event == true) {
            this.model.dataSource.forEach(row => {
                if (this.originalRoleIds.includes(row.id) && !this.roleEditable.includes(row.id)) {
                    return;
                }

                if (!this.originalRoleIds.some(x => x == row.id) || this.roleEditable.includes(row.id)) {
                    this.roleIds = [...this.roleIds, row.id];
                }
            });
        }
        else {
            this.model.dataSource.forEach(row => {
                if (this.originalRoleIds.includes(row.id) && !this.roleEditable.includes(row.id)) {
                    return;
                }

                if (!this.originalRoleIds.some(x => x == row.id) || this.roleEditable.includes(row.id)) {
                    this.roleIds = this.roleIds.filter(x => x != row.id);
                }
            });
        }

        this.onChangeSelect(null);
    }

}
